'use strict';

angular.module('shiftTraderApp')
  .factory('OAuthKeys', function (ServerUrls, $injector) {

    var $http = $injector.get('$http');

    var keysPromise;

    return {
      getKeys: function () {
        if(angular.isUndefined(keysPromise)) {
          keysPromise = $http.get(ServerUrls.current.railsApi + 'keys');
        }
        return keysPromise;
      }
    };
  });
